/**
 * Do not edit directly
 * Generated from design tokens
 */

export const tokens = {
  global: {
    colors: {
      primary: {
        50: '#E6ECEB',
        100: '#B0C4C2',
        200: '#8AA7A4',
        400: '#336661',
        500: '#004039',
        600: '#003A34',
      },
      secondary: {
        500: '#FF8A5D',
        900: '#6b3a27',
      },
      tertiary: {
        100: '#F0E8DA',
        200: '#E3D8C1',
        500: '#FFEFDA',
      },
      neutral: {
        100: '#F5F5F5',
        200: '#E5E5E5',
        300: '#CCCCCC',
        400: '#B3B3B3',
        500: '#999999',
        600: '#808080',
        700: '#666666',
        800: '#444444',
        900: '#333333',
        '900-alpha40': 'rgba(51,51,51,0.40)',
      },
      base: {
        white: '#FFFFFF',
        black: '#000000',
      },
      informative: {
        50: '#E6FAF9',
        100: '#B0EFEC',
        700: '#00918A',
      },
      success: {
        50: '#E8F8EF',
        700: '#0e8343',
      },
      warning: {
        50: '#FEFAE9',
        100: '#FBF1BB',
        300: '#F7E06D',
        700: '#ad941a',
      },
      error: {
        50: '#FDEAEA',
        100: '#F8BFBF',
        300: '#F07474',
        700: '#a52222',
      },
    },
    elevations: {
      none: 'none',
      sm: {
        shadow1: {
          x: 0,
          y: 1,
          blur: 2,
          spread: 0,
          color: 'rgba(0,0,0,0.06)',
          value: '0px 1px 2px 0px rgba(0,0,0,0.06)',
        },
        shadow2: {
          x: 0,
          y: 1,
          blur: 3,
          spread: 0,
          color: 'rgba(0,0,0,0.10)',
          value: '0px 1px 3px 0px rgba(0,0,0,0.10)',
        },
      },
      md: {
        shadow1: {
          x: 0,
          y: 2,
          blur: 4,
          spread: -1,
          color: 'rgba(0,0,0,0.06)',
          value: '0px 2px 4px -1px rgba(0,0,0,0.06)',
        },
        shadow2: {
          x: 0,
          y: 4,
          blur: 6,
          spread: -1,
          color: 'rgba(0,0,0,0.10)',
          value: '0px 4px 6px -1px rgba(0,0,0,0.10)',
        },
      },
      lg: {
        shadow1: {
          x: 0,
          y: 4,
          blur: 6,
          spread: -2,
          color: 'rgba(0,0,0,0.05)',
          value: '0px 4px 6px -2px rgba(0,0,0,0.05)',
        },
        shadow2: {
          x: 0,
          y: 10,
          blur: 15,
          spread: -3,
          color: 'rgba(0,0,0,0.10)',
          value: '0px 10px 15px -3px rgba(0,0,0,0.10)',
        },
      },
      xl: {
        shadow1: {
          x: 0,
          y: 10,
          blur: 10,
          spread: -5,
          color: 'rgba(0,0,0,0.04)',
          value: '0px 10px 10px -5px rgba(0,0,0,0.04)',
        },
        shadow2: {
          x: 0,
          y: 20,
          blur: 25,
          spread: -5,
          color: 'rgba(0,0,0,0.10)',
          value: '0px 20px 25px -5px rgba(0,0,0,0.10)',
        },
      },
    },
    breakpoints: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
    },
    layouts: {
      devices: {
        desktop: {
          width: '1440px',
          height: '1024px',
        },
        tablet: {
          width: '744px',
          height: '1133px',
        },
        mobile: {
          width: '390px',
          height: '844px',
        },
      },
      sidebar: {
        width: '240px',
      },
    },
    grid: {
      desktop: {
        columns: '12',
        gutter: '16px',
        margin: '88px',
        type: 'fluid',
      },
      tablet: {
        columns: '8',
        gutter: '16px',
        margin: '24px',
        type: 'stretch',
      },
      mobile: {
        columns: '4',
        gutter: '16px',
        margin: '16px',
        type: 'stretch',
      },
      'desktop-with-sidebar': {
        content: {
          'max-width': '1200px',
        },
        columns: '8',
        gutter: '16px',
        margin: '24px',
      },
    },
    radius: {
      none: '0px',
      xs: '4px',
      sm: '8px',
      md: '16px',
      full: '9999px',
    },
    spacing: {
      2: '2px',
      4: '4px',
      8: '8px',
      12: '12px',
      16: '16px',
      24: '24px',
      32: '32px',
      40: '40px',
      48: '48px',
      64: '64px',
      80: '80px',
    },
    space: {
      2: '2px',
      4: '4px',
      8: '8px',
      12: '12px',
      16: '16px',
      24: '24px',
      32: '32px',
      40: '40px',
      48: '48px',
      64: '64px',
      80: '80px',
    },
    font: {
      family: {
        primary: 'Aeonik',
      },
      weight: {
        regular: '400',
        medium: '500',
        bold: '700',
      },
      size: {
        11: '11px',
        12: '12px',
        14: '14px',
        16: '16px',
        18: '18px',
        20: '20px',
        22: '22px',
        36: '36px',
        56: '56px',
      },
      'line-height': {
        16: '16px',
        20: '20px',
        24: '24px',
        28: '28px',
        32: '32px',
        48: '48px',
        73: '73px',
      },
    },
    typography: {
      headline: {
        h1: {
          fontFamily: '{font.family.primary}',
          fontWeight: '{font.weight.regular}',
          fontSize: '{font.size.56}',
          lineHeight: '{font.line-height.73}',
        },
        h2: {
          fontFamily: '{font.family.primary}',
          fontWeight: '{font.weight.medium}',
          fontSize: '{font.size.36}',
          lineHeight: '{font.line-height.48}',
        },
      },
      title: {
        lg: {
          fontFamily: '{font.family.primary}',
          fontWeight: '{font.weight.medium}',
          fontSize: '{font.size.22}',
          lineHeight: '{font.line-height.32}',
        },
        md: {
          fontFamily: '{font.family.primary}',
          fontWeight: '{font.weight.medium}',
          fontSize: '{font.size.20}',
          lineHeight: '{font.line-height.28}',
        },
        sm: {
          fontFamily: '{font.family.primary}',
          fontWeight: '{font.weight.medium}',
          fontSize: '{font.size.18}',
          lineHeight: '{font.line-height.24}',
        },
      },
      body: {
        xl: {
          fontFamily: '{font.family.primary}',
          fontWeight: '{font.weight.regular}',
          fontSize: '{font.size.20}',
          lineHeight: '{font.line-height.24}',
        },
        lg: {
          fontFamily: '{font.family.primary}',
          fontWeight: '{font.weight.regular}',
          fontSize: '{font.size.18}',
          lineHeight: '{font.line-height.24}',
        },
        md: {
          regular: {
            fontFamily: '{font.family.primary}',
            fontWeight: '{font.weight.regular}',
            fontSize: '{font.size.16}',
            lineHeight: '{font.line-height.24}',
          },
          medium: {
            fontFamily: '{font.family.primary}',
            fontWeight: '{font.weight.medium}',
            fontSize: '{font.size.16}',
            lineHeight: '{font.line-height.24}',
          },
        },
        sm: {
          regular: {
            fontFamily: '{font.family.primary}',
            fontWeight: '{font.weight.regular}',
            fontSize: '{font.size.14}',
            lineHeight: '{font.line-height.20}',
          },
          medium: {
            fontFamily: '{font.family.primary}',
            fontWeight: '{font.weight.medium}',
            fontSize: '{font.size.14}',
            lineHeight: '{font.line-height.20}',
          },
        },
      },
      label: {
        md: {
          regular: {
            fontFamily: '{font.family.primary}',
            fontWeight: '{font.weight.regular}',
            fontSize: '{font.size.12}',
            lineHeight: '{font.line-height.16}',
          },
          medium: {
            fontFamily: '{font.family.primary}',
            fontWeight: '{font.weight.medium}',
            fontSize: '{font.size.12}',
            lineHeight: '{font.line-height.16}',
          },
        },
        sm: {
          fontFamily: '{font.family.primary}',
          fontWeight: '{font.weight.medium}',
          fontSize: '{font.size.11}',
          lineHeight: '{font.line-height.16}',
        },
      },
    },
    icons: {
      sizes: {
        16: '16px',
        24: '24px',
        32: '32px',
        48: '48px',
      },
      stroke: {
        weight: '2px',
      },
      styles: {
        outlined: 'outlined',
        filled: 'filled',
      },
      source: {
        web: 'Carbon',
        figma: 'IBM Carbon Icons',
      },
      naming: {
        pattern: 'icon-[library icon name]',
      },
    },
    logo: {
      types: {
        full: 'qida',
        symbol: 'q',
        footer: 'footer',
      },
      sizes: {
        sm: {
          height: '24px',
          width: {
            full: '40px',
            symbol: '24px',
          },
        },
        md: {
          height: '40px',
          width: {
            full: '80px',
            symbol: '40px',
          },
        },
        lg: {
          height: '64px',
          width: {
            full: '160px',
            symbol: '80px',
            footer: '384px',
          },
        },
      },
      colors: {
        white: '{color.base.white.value}',
        black: '{color.base.black.value}',
        primary: '{color.primary.900.value}',
      },
      padding: {
        symbol: {
          sm: '3px',
          md: '5px',
          lg: '10px',
        },
      },
      'aspect-ratio': {
        full: '2.5/1',
        symbol: '0.9/1',
        footer: '6/1',
      },
    },
  },
  components: {
    button: {
      base: {
        borderRadius: '{radius.lg}',
        minWidth: '96px',
        gap: '{space.8}',
        fontFamily: 'Aeonik',
        fontWeight: '{typography.weight.medium}',
        textCase: 'lowercase',
        padding: {
          horizontal: '{space.16}',
        },
        textAlign: 'center',
        verticalGroupSpacing: '{space.16}',
        horizontalGroupSpacing: '{space.16}',
      },
      size: {
        sm: {
          height: '24px',
          padding: {
            vertical: '{space.8}',
          },
          fontSize: '{typography.size.xs}',
          lineHeight: '1',
          iconSize: '16px',
        },
        md: {
          height: '40px',
          padding: {
            vertical: '{space.8}',
          },
          fontSize: '{typography.size.sm}',
          lineHeight: '1.25',
          iconSize: '24px',
        },
        lg: {
          height: '48px',
          padding: {
            vertical: '{space.8}',
          },
          fontSize: '{typography.size.sm}',
          lineHeight: '1.25',
          iconSize: '24px',
        },
      },
      variant: {
        primary: {
          background: {
            enabled: '{color.primary.900}',
            hovered: '{color.slate.600}',
            pressed: '{color.teal.950}',
            disabled: '{color.gray.400}',
          },
          text: {
            enabled: '{color.white}',
            hovered: '{color.white}',
            pressed: '{color.white}',
            disabled: '{color.white}',
          },
          icon: {
            enabled: '{color.white}',
            hovered: '{color.white}',
            pressed: '{color.white}',
            disabled: '{color.white}',
          },
          border: {
            enabled: 'none',
          },
          focused: {
            outline: {
              width: '4px',
              offset: '-2px',
              color: '{color.gray.400}',
            },
          },
        },
        secondary: {
          background: {
            enabled: 'transparent',
            hovered: '{color.gray.200}',
            pressed: '{color.gray.400}',
            disabled: 'transparent',
          },
          text: {
            enabled: '{color.primary.900}',
            hovered: '{color.primary.900}',
            pressed: '{color.primary.900}',
            disabled: '{color.slate.600}',
          },
          icon: {
            enabled: '{color.primary.900}',
            hovered: '{color.primary.900}',
            pressed: '{color.primary.900}',
            disabled: '{color.slate.600}',
          },
          border: {
            enabled: {
              width: '1px',
              color: '{color.primary.900}',
            },
            disabled: {
              color: '{color.gray.400}',
            },
          },
          focused: {
            outline: {
              width: '4px',
              offset: '-4px',
              color: '{color.gray.400}',
            },
          },
        },
        tertiary: {
          background: {
            enabled: 'transparent',
            hovered: '{color.gray.200}',
            pressed: '{color.gray.400}',
            disabled: 'transparent',
          },
          text: {
            enabled: '{color.primary.900}',
            hovered: '{color.primary.900}',
            pressed: '{color.primary.900}',
            disabled: '{color.slate.600}',
          },
          icon: {
            enabled: '{color.primary.900}',
            hovered: '{color.primary.900}',
            pressed: '{color.primary.900}',
            disabled: '{color.slate.600}',
          },
          border: {
            enabled: 'none',
          },
          focused: {
            outline: {
              width: '4px',
              offset: '-2px',
              color: '{color.gray.400}',
            },
          },
        },
      },
      icon: {
        position: {
          left: {
            paddingLeft: '{space.16}',
            paddingRight: '{space.24}',
          },
          right: {
            paddingLeft: '{space.24}',
            paddingRight: '{space.16}',
          },
        },
      },
      loading: {
        iconPadding: {
          sm: '2px',
          md: '3px',
          lg: '3px',
        },
      },
    },
    'button-icon': {
      base: {
        borderRadius: '{radius.lg}',
        sizes: {
          md: {
            width: '40px',
            height: '40px',
            iconSize: '24px',
            padding: '{space.6}',
          },
          lg: {
            width: '48px',
            height: '48px',
            iconSize: '24px',
            padding: '{space.6}',
          },
        },
      },
      variant: {
        primary: {
          background: {
            enabled: '{color.primary.900}',
            hovered: '{color.slate.600}',
            pressed: '{color.teal.950}',
            disabled: '{color.gray.400}',
          },
          icon: {
            enabled: '{color.white}',
            hovered: '{color.white}',
            pressed: '{color.white}',
            disabled: '{color.white}',
          },
        },
        secondary: {
          background: {
            enabled: 'transparent',
            hovered: '{color.gray.200}',
            pressed: '{color.gray.400}',
            disabled: 'transparent',
          },
          icon: {
            enabled: '{color.primary.900}',
            hovered: '{color.primary.900}',
            pressed: '{color.primary.900}',
            disabled: '{color.slate.600}',
          },
          border: {
            enabled: {
              width: '1px',
              color: '{color.primary.900}',
            },
            disabled: {
              color: '{color.gray.400}',
            },
          },
        },
        tertiary: {
          background: {
            enabled: 'transparent',
            hovered: '{color.gray.200}',
            pressed: '{color.gray.400}',
            disabled: 'transparent',
          },
          icon: {
            enabled: '{color.zinc.800}',
            hovered: '{color.zinc.800}',
            pressed: '{color.zinc.800}',
            disabled: '{color.stone.500}',
          },
        },
        tonal: {
          background: {
            enabled: '{color.neutral.100}',
            hovered: '{color.neutral.200}',
            pressed: '{color.stone.300}',
            disabled: '{color.neutral.100}',
          },
          icon: {
            enabled: '{color.zinc.800}',
            hovered: '{color.zinc.800}',
            pressed: '{color.zinc.800}',
            disabled: '{color.stone.500}',
          },
        },
      },
    },
    'button-fab': {
      base: {
        background: {
          enabled: '{color.primary.900}',
          hovered: '{color.slate.600}',
          pressed: '{color.teal.950}',
          disabled: '{color.gray.400}',
        },
        icon: {
          color: '{color.white}',
          size: '24px',
        },
        shadow: '{elevation.lg}',
        sizes: {
          sm: {
            width: '40px',
            height: '40px',
            borderRadius: '{radius.lg}',
            padding: '{space.10}',
          },
          md: {
            width: '56px',
            height: '56px',
            borderRadius: '{radius.2xl}',
            padding: '{space.10}',
          },
        },
        position: 'bottom-right',
      },
    },
    accordion: {
      base: {
        padding: '{space.16}',
        borderRadius: '{radius.sm}',
        gap: '{space.8}',
        label: {
          typography: '{typography.title.sm}',
          color: '{color.neutral.800}',
        },
        icon: {
          size: '24px',
          color: '{color.neutral.800}',
        },
      },
      state: {
        closed: {
          indicator: {
            rotation: '0deg',
          },
          content: {
            display: 'none',
          },
        },
        opened: {
          indicator: {
            rotation: '180deg',
          },
          content: {
            display: 'block',
            padding: '{space.16} {space.16} {space.16} {space.16}',
          },
        },
      },
      responsive: {
        desktop: {
          width: '100%',
          maxWidth: '824px',
        },
        mobile: {
          width: '100%',
          maxWidth: '100%',
        },
      },
      accessibility: {
        focusRing: '2px solid {color.primary.500}',
        keyboardSupport: {},
        ariaAttributes: {},
      },
    },
    avatars: {
      sizes: {
        sm: '24px',
        md: '32px',
        lg: '48px',
      },
      types: {
        icon: 'Icon Representation',
        image: 'Image Representation',
        text: 'Text Representation',
      },
      borderRadius: '{global.radius.full}',
    },
    'alert-toast': {
      base: {
        padding: '{space.16}',
        borderRadius: '{radius.sm}',
        gap: '{space.8}',
        text: {
          color: '{color.neutral.800}',
          typography: '{typography.body.md.regular}',
        },
        icon: {
          size: '24px',
          padding: '1px',
        },
        shadow: [
          {
            x: '0',
            y: '10px',
            blur: '10px',
            spread: '-5px',
            color: 'rgba(0,0,0,0.04)',
          },
        ],
        position: 'bottom-right',
        maxWidth: '320px',
        zIndex: '1000',
        duration: '5000ms',
        animation: {
          entry: 'slide-in-right 0.3s ease-out',
          exit: 'fade-out 0.3s ease-in',
        },
      },
      type: {
        informative: {
          background: '{color.primary.50}',
          icon: {
            color: '{color.informative.600}',
          },
        },
        success: {
          background: '{color.primary.50}',
          icon: {
            color: '{color.success.700}',
          },
        },
        warning: {
          background: '{color.warning.50}',
          icon: {
            color: '{color.warning.600}',
          },
        },
        error: {
          background: '{color.error.100}',
          icon: {
            color: '{color.error.800}',
          },
        },
      },
      stacking: {
        gap: '{space.8}',
        maxCount: '3',
      },
      accessibility: {
        role: 'status',
        liveRegion: 'polite',
        minDuration: '5000ms',
      },
    },
    badges: {
      sizes: {
        sm: '12px',
        md: '16px',
        lg: '24px',
      },
      types: {
        badge: 'Standard Badge',
        'badge-icon': 'Badge with Icon',
      },
      borderRadius: '{global.radius.full}',
      padding: '{global.spacing.8} {global.spacing.12}',
      background: '{global.colors.primary.500}',
      text: '{global.colors.base.white}',
    },
    breadcrumb: {
      styles: {
        desktop: {
          maxLevels: '3',
          truncation: 'true',
          color: '{global.colors.neutral.900}',
          separatorColor: '{global.colors.neutral.700}',
          fontSize: '{global.typography.fontSizes.title-md}',
        },
        mobile: {
          maxLevels: '1',
          backNavigation: 'true',
          color: '{global.colors.neutral.900}',
          fontSize: '{global.typography.fontSizes.title-sm}',
        },
      },
      padding: '{global.spacing.8}',
      margin: '{global.spacing.12}',
    },
    cards: {
      variants: {
        default: {
          background: '{global.colors.base.white}',
          border: '{global.colors.neutral.200}',
          shadow: '{global.elevations.sm}',
          borderRadius: '8px',
          padding: '24px',
        },
        elevated: {
          background: '{global.colors.base.white}',
          border: 'none',
          shadow: '{global.elevations.lg}',
          borderRadius: '12px',
          padding: '24px',
        },
        outlined: {
          background: '{global.colors.base.white}',
          border: '{global.colors.primary.200}',
          shadow: 'none',
          borderRadius: '8px',
          padding: '24px',
        },
        info: {
          background: '{global.colors.informative.50}',
          border: '{global.colors.informative.100}',
          shadow: 'none',
          borderRadius: '8px',
          padding: '16px',
          iconColor: '{global.colors.informative.500}',
        },
        vcx: {
          background: '{global.colors.base.white}',
          border: '{global.colors.primary.100}',
          shadow: '{global.elevations.sm}',
          borderRadius: '12px',
          padding: '24px',
          accentColor: '{global.colors.primary.500}',
        },
      },
      header: {
        padding: '0 0 16px 0',
        fontSize: '18px',
        fontWeight: '600',
      },
      content: {
        padding: '0',
        fontSize: '14px',
        lineHeight: '1.5',
        color: '{global.colors.neutral.700}',
      },
      footer: {
        padding: '24px 0 0 0',
        borderTop: 'none',
        gap: '16px',
      },
      cta: {
        primary: {
          background: '{global.colors.primary.500}',
          color: '{global.colors.base.white}',
          borderRadius: '6px',
          padding: '10px 20px',
          fontSize: '14px',
        },
        secondary: {
          background: 'transparent',
          color: '{global.colors.primary.500}',
          borderRadius: '6px',
          padding: '10px 20px',
          fontSize: '14px',
        },
      },
      layout: {
        horizontal: {
          displayType: 'flex',
          gap: '20px',
        },
        vertical: {
          displayType: 'block',
          gap: '16px',
        },
      },
    },
    charts: {
      colors: {
        primary: '{global.colors.primary.500}',
        secondary: '{global.colors.secondary.500}',
        tertiary: '{global.colors.tertiary.500}',
        palette: {
          color1: '#2C8970',
          color2: '#FA541C',
          color3: '#B7A673',
          color4: '#1890FF',
          color5: '#52C41A',
          color6: '#722ED1',
          color7: '#EB2F96',
          color8: '#FAAD14',
        },
      },
      typography: {
        title: {
          fontSize: '18px',
          fontWeight: '600',
          color: '{global.colors.neutral.900}',
        },
        subtitle: {
          fontSize: '14px',
          fontWeight: '400',
          color: '{global.colors.neutral.700}',
        },
        axis: {
          fontSize: '12px',
          fontWeight: '400',
          color: '{global.colors.neutral.600}',
        },
        label: {
          fontSize: '12px',
          fontWeight: '500',
          color: '{global.colors.neutral.800}',
        },
        tooltip: {
          fontSize: '12px',
          fontWeight: '400',
          color: '{global.colors.base.white}',
        },
      },
      grid: {
        line: {
          color: '{global.colors.neutral.200}',
          width: '1px',
          style: 'dashed',
        },
      },
      axis: {
        line: {
          color: '{global.colors.neutral.300}',
          width: '1px',
        },
        tick: {
          length: '5px',
          color: '{global.colors.neutral.300}',
        },
      },
      legend: {
        background: '{global.colors.base.white}',
        border: {
          color: '{global.colors.neutral.200}',
          width: '1px',
          radius: '4px',
        },
        padding: '8px 12px',
      },
      tooltip: {
        background: 'rgba(0, 0, 0, 0.75)',
        border: {
          radius: '4px',
        },
        padding: '8px 12px',
        shadow: '{global.elevations.md}',
      },
      types: {
        bar: {
          width: '12px',
          gap: '4px',
          radius: '2px',
        },
        line: {
          width: '2px',
          point: {
            size: '6px',
            hoverSize: '8px',
          },
        },
        area: {
          opacity: '0.5',
        },
        pie: {
          innerRadius: '0',
          donutRadius: '70%',
          padding: '10px',
        },
      },
      circular: {
        sizes: {
          sm: {
            diameter: '64px',
            thickness: '8px',
            fontSize: '16px',
            fontWeight: '600',
          },
          md: {
            diameter: '80px',
            thickness: '10px',
            fontSize: '18px',
            fontWeight: '600',
          },
        },
        variants: {
          primary: {
            fillColor: '{global.colors.primary.500}',
            backgroundColor: '{global.colors.primary.100}',
            textColor: '{global.colors.neutral.800}',
          },
          secondary: {
            fillColor: '{global.colors.secondary.500}',
            backgroundColor: '{global.colors.secondary.100}',
            textColor: '{global.colors.neutral.800}',
          },
          tertiary: {
            fillColor: '{global.colors.tertiary.500}',
            backgroundColor: '{global.colors.tertiary.100}',
            textColor: '{global.colors.neutral.800}',
          },
          success: {
            fillColor: '{global.colors.success.500}',
            backgroundColor: '{global.colors.success.50}',
            textColor: '{global.colors.neutral.800}',
          },
          info: {
            fillColor: '{global.colors.informative.500}',
            backgroundColor: '{global.colors.informative.50}',
            textColor: '{global.colors.neutral.800}',
          },
        },
      },
    },
    checkbox: {
      sizes: {
        sm: {
          size: '16px',
          borderRadius: '2px',
          fontSize: '14px',
        },
        md: {
          size: '20px',
          borderRadius: '3px',
          fontSize: '16px',
        },
      },
      states: {
        default: {
          border: '{global.colors.neutral.400}',
          background: 'transparent',
          labelColor: '{global.colors.neutral.800}',
        },
        hover: {
          border: '{global.colors.primary.400}',
          background: 'transparent',
          labelColor: '{global.colors.neutral.900}',
        },
        focus: {
          border: '{global.colors.primary.500}',
          background: '{global.colors.primary.50}',
          labelColor: '{global.colors.neutral.800}',
        },
        checked: {
          border: '{global.colors.primary.500}',
          background: '{global.colors.primary.500}',
          labelColor: '{global.colors.neutral.800}',
          icon: '{global.colors.base.white}',
        },
        disabled: {
          border: '{global.colors.neutral.300}',
          background: '{global.colors.neutral.200}',
          labelColor: '{global.colors.neutral.500}',
          icon: '{global.colors.neutral.500}',
        },
        error: {
          border: '{global.colors.error.500}',
          background: '{global.colors.error.50}',
          labelColor: '{global.colors.neutral.800}',
          icon: '{global.colors.error.500}',
        },
      },
      spacing: {
        labelGap: '8px',
        marginBottom: '12px',
      },
    },
    radio: {
      sizes: {
        sm: {
          size: '16px',
          innerSize: '8px',
          fontSize: '14px',
        },
        md: {
          size: '20px',
          innerSize: '10px',
          fontSize: '16px',
        },
      },
      states: {
        default: {
          border: '{global.colors.neutral.400}',
          background: 'transparent',
          labelColor: '{global.colors.neutral.800}',
        },
        hover: {
          border: '{global.colors.primary.400}',
          background: 'transparent',
          labelColor: '{global.colors.neutral.900}',
        },
        focus: {
          border: '{global.colors.primary.500}',
          background: '{global.colors.primary.50}',
          labelColor: '{global.colors.neutral.800}',
        },
        checked: {
          border: '{global.colors.primary.500}',
          background: '{global.colors.base.white}',
          dot: '{global.colors.primary.500}',
          labelColor: '{global.colors.neutral.800}',
        },
        disabled: {
          border: '{global.colors.neutral.300}',
          background: '{global.colors.neutral.200}',
          dot: '{global.colors.neutral.500}',
          labelColor: '{global.colors.neutral.500}',
        },
        error: {
          border: '{global.colors.error.500}',
          background: '{global.colors.error.50}',
          dot: '{global.colors.error.500}',
          labelColor: '{global.colors.neutral.800}',
        },
      },
      spacing: {
        labelGap: '8px',
        marginBottom: '12px',
      },
    },
    'alert-sticky': {
      base: {
        padding: '{space.16}',
        borderRadius: '{radius.sm}',
        gap: '{space.16}',
        text: {
          color: '{color.neutral.800}',
          typography: '{typography.body.md.regular}',
          mixBlendMode: 'multiply',
        },
        icon: {
          size: '24px',
          padding: '1px',
        },
        closeButton: {
          size: '24px',
          padding: '6px',
          iconColor: '{color.neutral.800}',
        },
        shadow: [
          {
            x: '0',
            y: '1px',
            blur: '2px',
            spread: '0',
            color: 'rgba(0,0,0,0.06)',
          },
          {
            x: '0',
            y: '1px',
            blur: '3px',
            spread: '0',
            color: 'rgba(0,0,0,0.10)',
          },
        ],
      },
      type: {
        informative: {
          background: '{color.primary.50}',
          icon: {
            color: '{color.informative.600}',
          },
        },
        success: {
          background: '{color.primary.50}',
          icon: {
            color: '{color.success.700}',
          },
        },
        warning: {
          background: '{color.warning.50}',
          icon: {
            color: '{color.warning.600}',
          },
        },
        error: {
          background: '{color.error.100}',
          icon: {
            color: '{color.error.800}',
          },
        },
      },
      link: {
        color: '{color.primary.900}',
        typography: '{typography.body.md.regular}',
        textDecoration: 'underline',
        gap: '{space.8}',
        icon: {
          size: '16px',
          color: '{color.primary.900}',
        },
      },
      responsive: {
        desktop: {
          width: '100%',
          maxWidth: '720px',
          layout: {
            singleLine: 'flex',
            multiLine: {},
          },
        },
        mobile: {
          width: '100%',
          maxWidth: '384px',
          layout: {},
        },
      },
      accessibility: {
        role: 'alert',
        liveRegion: 'assertive',
        focusable: {},
      },
    },
  },
}
